// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // Endpoints
    URL_BASE: process.env.REACT_APP_URL_BASE || '',
}
